export const contact = [
   
    {name: 'phone', number: '+60 17 807 5498'},
    {name: 'tg', number: 'https://t.me/WitConsulting',},
]